/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import LocaleMessage from '~/components/LocaleMessage';
import SectionsForm from '~/components/Sections/Form';

import CheckGroupPermission from '~/util/CheckGroupPermission';

export default function GroupSectionForm({ match }) {
    const user = useSelector(state => state.user);

    const { id, section_id } = match.params;
    const permissions = CheckGroupPermission(user || {}, id);

    const allowEdit = permissions.allow;
    const adminMode = permissions.admin;

    return (
        <SectionsForm
            breadcrumbs={[
                {
                    url: '/groups',
                    title: <LocaleMessage msg="breadcrumbs.groups" />,
                },
                {
                    url: `/groups/${id}/sections`,
                    title: <LocaleMessage msg="breadcrumbs.group.sections" />,
                },
            ]}
            adminMode={adminMode}
            allowEdit={allowEdit}
            linkRoot={`/groups/${id}`}
            section_id={section_id}
            group_id={id}
        />
    );
}

GroupSectionForm.propTypes = {
    match: PropTypes.object.isRequired,
};
